import type { FC } from 'react';
import styled, { useTheme } from 'styled-components';
import GreenArrowUp from '../../../../assets/GreenArrowUp.svg';
import RedArrowDown from '../../../../assets/RedArrowDown.svg';
import LineIcon from '../../../../assets/Line.svg';

export const enum TrendType {
  UP = 'up',
  DOWN = 'down',
  FLAT = 'flat',
}

// Insert an alpha channel into an `hsl(h s l)` token -> `hsl(h s l / a)`.
const withAlpha = (color: string, alpha: number) => color.replace(/\)\s*$/, ` / ${alpha})`);

type BehaviourTrendProps = {
  value: number;
  type: TrendType;
};

export const BehaviourTrend: FC<BehaviourTrendProps> = ({ value, type }) => {
  const { colors } = useTheme();
  const p = colors.prototype;

  const trendMap = {
    [TrendType.UP]: {
      backgroundColor: withAlpha(p.success, 0.1),
      color: p.successText,
      icon: <GreenArrowUp />,
    },
    [TrendType.DOWN]: {
      backgroundColor: withAlpha(p.destructive, 0.1),
      color: p.destructiveText,
      icon: <RedArrowDown />,
    },
    [TrendType.FLAT]: {
      backgroundColor: p.secondary,
      color: p.mutedForeground,
      icon: <LineIcon />,
    },
  } as const;

  return (
    <BehaviourTrendContainer $backgroundColor={trendMap[type].backgroundColor} color={trendMap[type].color}>
      {trendMap[type].icon}
      <TrendValue>{`${value}%`}</TrendValue>
    </BehaviourTrendContainer>
  );
};

export const BehaviourTrendContainer = styled.div<{ $backgroundColor: string; color: string }>`
  display: inline-flex;
  height: 22px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  padding: 2px 6px;
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.color};

  svg {
    width: 14px;
    height: 14px;
  }

  /* Let the arrow/line icons follow the pill text color so they adapt to light/dark */
  svg path {
    stroke: currentColor;
  }
`;
export const TrendValue = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
`;
